<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>  
<app-pulsemenu></app-pulsemenu>
<div class="container" style="margin-top:80px">
<div class="card" style="background: #dbd3be; width:100%; margin-bottom: 100px">
    <div class="card-body">
  <div class="row">
    <div class="col-3" center text-center>
            <label>Enter Subject for Notification</label>
           
    </div>
    <div class="col-9" text-left>
        <textarea rows="4" [(ngModel)]="subject" style="width:100%" ></textarea>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="row">
      <div class="col-6" center text-center>
              <label>Enter Type Of Notification</label>
             
      </div>
      <div class="col-6" text-left>
          <select  [(ngModel)]="type" >
              <option value="vaccination">Vaccination</option>
              <option value="appointment">Appointment</option>
          </select>
      </div>
    </div>
    </div>
    <div class="col-6">
        <div class="row">
            <div class="col-6" center text-center>
                    <label>Set Notification Date</label>
                   
            </div>
            <div class="col-6" text-left>
                <input type="date" time="false" date="true"  [(ngModel)]="remdate" >
            </div>
          </div>
    </div>
    </div>      
    <div class="row" style="margin:10px">
      <div class="col-6 " center text-center>
        <button class="btn btn-success" (click)="setReminder()">Set Reminder with Us</button>
      </div>
      <div class="col-6 " text-right>
          <button class="btn btn-success2">Cancel</button>
      </div>
    </div>   
    
</div>
</div>
</div>
